import {axiosOnline, withdrawal} from '../../api/apiIndex'
import { Message } from 'element-ui';
import i18n from "../../utils/lang/index.js";

export default {
  state: {
    tradingRules: [],
    withdraw_post: {
      name: "",
      money: "",
      account: "",
      member_bank_id: "",
      member_bank_text: "",
      member_remark: "",
      qk_pwd: "",
      payment_type: "",
      // created_at: "",
      cpf_id: "",
      phone_number: "",
      email: "",
      cnpj: "",
      evp: "",
    },
  },
  getters: {},
  mutations: {
    setTradingRules(state, data) {
      state.tradingRules = data
    },
    setWithdrawPost(state, data) {
      state.withdraw_post = data
    }
  },
  actions: {
    getTradingRules(context) {
      let data = { lang: context.rootState.lang.language.value, domain: context.rootState.auth.userInfo.site }
      axiosOnline(data).then(res => {
        context.commit('setTradingRules', res.data)
      }).catch(err => {
        if (err.response.data.error == 'Unauthenticated.') {
          console.log("WITHDRAW ERROR: ", err.response.data.error)
        }
      })
    },
    setWithdrawPost(context, data) {
      withdrawal(data).then(res => {
        Message.success(res.message);
      }).catch(err => {
        Message.error(err.message);
      })
    },
    
    // getRechargeRecordList(context, data){
    //   transactionRecord(data).then(res => {
    //     context.commit("setRechargeRecordList", res.data);
        
    //     alert(`Recharge success!`);
    //   })
    //   .catch((err) => {
    //     alert(`Error in Recharge: ${err}`);
    //   });
    // },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/withdraw.js